import React, {Component} from "react";
import BasicModal from "../../../../Onboarding/Utilities/BasicModal";
import ShopSelectionModalContent from "../TikTokShop/ShopSelectionModalContent";

let _this;

export default class TikTokShopSetupModal extends Component{
    constructor(props){
        super(props);

        this.state = { open: false, channel: '' };
        _this = this;
    }

    static open(){
        _this.setState({ open: true }) //this is invoked from outside the component
    }
    static close(){
        _this.setState({ open: false }); //this is invoked from outside the component
    }
    handleClose = () => {
        _this.setState({ open: false }); //this is invoked within the component
    };

    render() {
        return(
            <BasicModal
                open={this.state.open}
                handleClose={this.handleClose}
                title={`Select a shop to connect with Chatdesk`}>
                <ShopSelectionModalContent handleClose={this.handleClose}/>
            </BasicModal>
        )
    }
}